export default __webpack_public_path__ + "static/organigrama-4e69183083e461cb0c9e4293f95cc0cc.png";